var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no_authority"},[_c('img',{staticClass:"authority_icon",attrs:{"src":require("../../assets/images/public/no_authority.png"),"alt":""}}),_c('p',[_vm._v("您没有访问权限")]),_c('p',[_vm._v("如有疑问，请联系客服")])])
}]

export { render, staticRenderFns }